var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { destroyMessage, setMessage } from '../ui';
import { isDev } from "./common";
/**
 * @description ShowErrorAlert generates content and sets/destroy message alert
 * @param {TShowErrorAlertProps} params
 */
export var ShowErrorAlert = function (params) {
    var key = params.key, title = params.title, errorMessage = params.errorMessage, status = params.status, _a = params.duration, duration = _a === void 0 ? 10 : _a, _b = params.isClosable, isClosable = _b === void 0 ? false : _b, _c = params.hasReportBtn, hasReportBtn = _c === void 0 ? true : _c, handleReportClick = params.handleReportClick;
    var onReportClick = function () {
        destroyMessage(key);
        handleReportClick === null || handleReportClick === void 0 ? void 0 : handleReportClick(key);
    };
    isDev() && console.log('ShowErrorAlert title', title);
    //Подстройка статусов sentry под статусы алертов
    var getAlertStatus = function (status) {
        switch (status) {
            case 'Error':
            case 'Critical':
            case 'Fatal':
                return 'error';
            case 'Warning':
                return 'warning';
            default:
                return 'info';
        }
    };
    var messageContent = _jsxs("div", __assign({ className: 'error-handler-message-content' }, { children: [_jsxs("div", __assign({ className: 'error-handler-message-content__title' }, { children: [_jsx("span", { children: title }), isClosable && (_jsx("div", __assign({ className: 'error-handler-message-content__title_close-btn', onClick: function () { return destroyMessage(key); } }, { children: _jsx("img", { height: 10, width: 10, alt: 'close-icon', src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wLjk5OTAyMyAxNS4xNDI2TDE1LjE0MTIgMS4wMDA0NCIgc3Ryb2tlPSIjMDA4OEU5IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPHBhdGggZD0iTTEgMTUuMTQyNkwxNS4xNDIxIDEuMDAwNDQiIHN0cm9rZT0iIzAwODhFOSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICAgIDxwYXRoIGQ9Ik0xNS4xNDI2IDE1LjE0MjZMMS4wMDA0NCAxLjAwMDQ0IiBzdHJva2U9IiMwMDg4RTkiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgoK' }) })))] })), _jsx("p", __assign({ className: 'error-handler-message-content__description' }, { children: errorMessage })), hasReportBtn && (_jsx("button", __assign({ className: 'error-handler-report-btn', onClick: onReportClick }, { children: "\u0421\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0435" })))] }));
    setMessage({
        key: key,
        status: getAlertStatus(status),
        text: messageContent,
        duration: duration,
    });
};
